import * as index from '@syncfusion/ej2-gantt';
index.Gantt.Inject( index.Filter,index.Selection,index.Sort,index.Reorder,index.Resize,index.Edit,index.DayMarkers,index.Toolbar,index.ContextMenu,index.ExcelExport,index.ColumnMenu);
export * from '@syncfusion/ej2-gantt';
